import React, { Component } from 'react';
import { Col, Form, Input, Row, Tabs } from 'antd';
import TreeOrg from './TreeOrg';
import TableOrg from './TableOrg';
import './page.less';

const { TabPane } = Tabs;
const { Search } = Input;
class TabDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      titleCondition: '',
    };
  }

  callback = () => {};

  onSearch = value => {
    this.setState({
      titleCondition: value,
    });

    this.loadData();
  };

  loadData = () => {
    const { titleCondition } = this.state;
  };

  render() {
    const { data } = this.state;
    return (
      <div style={{ height: '100px' }}>
        <Row>
          <Col span={4}>
            <TreeOrg />
          </Col>
          <Col span={20} style={{ paddingLeft: '10px' }} className="right-content">
            <div className="top-right">
              <Search placeholder="标题搜索" enterButton="搜索" onSearch={this.onSearch} />
            </div>
            <Tabs defaultActiveKey="0" onChange={this.callback}>
              <TabPane tab="全部" key="0">
                <TableOrg data={data} type="all" />
              </TabPane>
              <TabPane tab="审批中" key="1">
                <TableOrg data={data} type="todo" />
              </TabPane>
              <TabPane tab="已完成" key="2">
                <TableOrg data={data} type="done" />
              </TabPane>
              <TabPane tab="编辑中" key="3">
                <TableOrg data={data} type="toEdit" />
              </TabPane>
            </Tabs>
          </Col>
        </Row>
      </div>
    );
  }
}

export default Form.create({ wrappedComponentRef: true })(TabDetail);



// WEBPACK FOOTER //
// ./src/components/flow/PageMine.js